export const PROJECT_STATUS_LABELS: Record<string, string> = {
  NEW: 'New',
  IN_PROGRESS: 'In Progress',
  REVIEW: 'Review',
  COMPLETED: 'Completed',
  ON_HOLD: 'On Hold',
};

export const PROJECT_STATUS_CHIP: Record<
  string,
  'default' | 'primary' | 'warning' | 'success' | 'danger'
> = {
  NEW: 'default',
  IN_PROGRESS: 'primary',
  REVIEW: 'warning',
  COMPLETED: 'success',
  ON_HOLD: 'danger',
};
